import Card from 'components/Layout/Card';
import Loader from 'components/Layout/Loader';
import ChatContainer from 'components/V2ForNewAbstractFlow/ResourceSide/NewPaperDetails/Chat/ChatContainer';
import React, { useEffect, useRef, useState } from 'react';
import SideBar from './SideBar';
import SeachInput from 'components/form/SeachInput';
import { useDispatch } from 'react-redux';
import { fetchWhatsappChatSidebarData } from 'store/slices';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { getDataFromLocalStorage } from 'utils/helpers';
import { useNavigate } from 'react-router-dom';

const Whatsapp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(true);
  const chatRef = useRef();
  const [isTyping, setIsTyping] = useState(false);
  const [groupList, setGroupList] = useState([]);
  const [groupID, setGroupID] = useState('');
  const [isChatLoader, setIsChatLoader] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const getWhatsappChatSidebarData = async () => {
    const response = await dispatch(fetchWhatsappChatSidebarData());
    if (response?.data) {
      setGroupList(response?.data?.whatsapp_data);
      setGroupID(`${response?.data?.whatsapp_data[0]?.id || ''}`);
    }
    setIsLoader(false);
  };

  useEffect(() => {
    if (['0', '1', '6'].includes(getDataFromLocalStorage('user_type'))) {
      getWhatsappChatSidebarData();
    } else {
      navigate('/');
    }
  }, []);

  // Filter groupList based on searchTerm
  const filteredGroupList = groupList.filter((group) => {
    const fullName = `${group?.user?.first_name || ''} ${
      group?.user?.last_name || ''
    }`.toLowerCase();
    const phone = group?.phone_no?.toLowerCase() || '';
    const search = searchTerm.toLowerCase();

    return fullName.includes(search) || phone.includes(search);
  });

  // Find current groupData based on selected groupID from filtered list or original list (to prevent empty)
  const groupData =
    filteredGroupList.find((o) => `${o.id}` === `${groupID}`) ||
    groupList.find((o) => `${o.id}` === `${groupID}`) ||
    {};

  const name = groupData?.user
    ? `${groupData.user.first_name} ${groupData.user.last_name}`
    : '';

  useEffect(() => {
    if (!window.Pusher) {
      window.Pusher = Pusher;
    }

    const echo = new Echo({
      broadcaster: 'pusher',
      key: process.env.REACT_APP_PUSHER_KEY,
      cluster: process.env.REACT_APP_PUSHER_CLUSTER,
      forceTLS: true,
      disableStats: true,
    });

    const channel = echo.channel('whatsapp-sidebar-alert');
    channel.listen('.WhatsappSidebarAlert', (event) => {
      getWhatsappChatSidebarData();
    });

    return () => {
      // Proper way to leave/unsubscribe the channel
      channel.stopListening('.WhatsappSidebarAlert');
      echo.leave('whatsapp-sidebar-alert');
    };
  }, []);

  return (
    <div className={`row ${isLoader ? '' : 'flex-grow-1'}`} id="chat-container">
      {isLoader ? (
        <div className="col-12 d-flex justify-content-center align-items-center cpt-125 cpb-125">
          <Card>
            <Loader size="md" />
          </Card>
        </div>
      ) : (
        <>
          <div className="col-md-4 col-12 cmb-10">
            <div className="cmt-10 cpb-20 border-bottom d-flex justify-content-between align-items-center">
              <SeachInput
                placeholder="Search"
                onChange={(e) => setSearchTerm(e.target.value)}
                value={searchTerm}
              />
            </div>
            <div>
              <SideBar
                chatRef={chatRef}
                isTyping={isTyping}
                groupData={groupData}
                groupList={filteredGroupList}
                setGroupID={(id) => {
                  setIsChatLoader(true);
                  setGroupID(id);
                }}
              />
            </div>
          </div>

          <div className="col-md-8 col-12">
            <ChatContainer
              name={name}
              whatsapp_number={groupData?.phone_no}
              user_id={groupData?.user_id}
              profile_photo_path={groupData?.user?.profile_photo_path}
              isChatLoader={isChatLoader}
              setIsChatLoader={setIsChatLoader}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default Whatsapp;

// import Card from 'components/Layout/Card';
// import Loader from 'components/Layout/Loader';
// import ChatContainer from 'components/V2ForNewAbstractFlow/ResourceSide/NewPaperDetails/Chat/ChatContainer';
// import React, { useEffect, useRef, useState } from 'react';
// import SideBar from './SideBar';
// import { getDataFromLocalStorage } from 'utils/helpers';
// import SeachInput from 'components/form/SeachInput';
// import { useDispatch } from 'react-redux';
// import { fetchWhatsappChatSidebarData } from 'store/slices';
// import Echo from 'laravel-echo';
// import Pusher from 'pusher-js';

// const Whatsapp = () => {
//   const dispatch = useDispatch();
//   const [isLoader, setIsLoader] = useState(true);
//   const chatRef = useRef();
//   const [isTyping, setIsTyping] = useState(false);
//   const [groupList, setGroupList] = useState([]);
//   const [groupID, setGroupID] = useState(`${groupList[0]?.id}`);
//   const [isChatLoader, setIsChatLoader] = useState(false);
//   const [echoInstance, setEchoInstance] = useState(null);

//   //   useEffect(() => {
//   //     // Initialize Pusher only once
//   //     if (!window.Pusher) {
//   //       window.Pusher = Pusher;
//   //     }

//   //     const echo = new Echo({
//   //       broadcaster: 'pusher',
//   //       key: process.env.REACT_APP_PUSHER_KEY,
//   //       cluster: process.env.REACT_APP_PUSHER_CLUSTER,
//   //       forceTLS: true,
//   //       disableStats: true,
//   //     });

//   //     setEchoInstance(echo);

//   //     // Subscribe to a unique channel based on chatId
//   //     const channel = echo.channel(`whatsapp-sidebar-alert`);
//   // console.log('✌️channel --->', channel);
//   //     channel.listen('.WhatsappSidebarAlert', (data) => {
//   //       console.log('📥 WhatsappSidebarAlert received:', data);
//   //     });

//   //     return () => {
//   //       if (echoInstance) {
//   //         echoInstance.leaveChannel(`whatsapp-sidebar-alert`);
//   //       }
//   //     };
//   //   }, []);

//   const getWhatsappChatSidebarData = async () => {
//     const response = await dispatch(fetchWhatsappChatSidebarData());
//     if (response?.data) {
//       setGroupList(response?.data?.whatsapp_data);
//       setGroupID(`${response?.data?.whatsapp_data[0].id}`);
//     }
//     setIsLoader(false);
//   };

//   useEffect(() => {
//     getWhatsappChatSidebarData();
//   }, []);

//   const groupData = groupList?.find((o) => `${o.id}` === `${groupID}`) || {};
//   const name = groupData?.user
//     ? `${groupData.user.first_name} ${groupData.user.last_name}`
//     : '';

//   return (
//     <div className={`row ${isLoader ? '' : 'flex-grow-1'}`} id="chat-container">
//       {isLoader ? (
//         <div className="col-12 d-flex justify-content-center align-items-center cpt-125 cpb-125">
//           <Card>
//             <Loader size="md" />
//           </Card>
//         </div>
//       ) : (
//         <>
//           <div className="col-md-4 col-12">
//             <div className="cmt-10 cpb-20 border-bottom d-flex justify-content-between align-items-center">
//               <SeachInput placeholder="Search" />
//             </div>
//             <div>
//               <SideBar
//                 chatRef={chatRef}
//                 isTyping={isTyping}
//                 groupData={groupData}
//                 groupList={groupList}
//                 setGroupID={(id) => {
//                   setIsChatLoader(true);
//                   setGroupID(id);
//                 }}
//               />
//             </div>
//           </div>

//           <div className="col-md-8 col-12">
//             <ChatContainer
//               name={name}
//               whatsapp_number={groupData?.phone_no}
//               user_id={groupData?.user_id}
//               profile_photo_path={groupData?.user?.profile_photo_path}
//               isChatLoader={isChatLoader}
//               setIsChatLoader={setIsChatLoader}
//             />
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default Whatsapp;

// import React, { useState, useEffect } from 'react';
// import Echo from 'laravel-echo';
// import Pusher from 'pusher-js';

// const Whatsapp = () => {
//   const [messages, setMessages] = useState([]);

//   useEffect(() => {
//     // Configure Pusher globally
//     window.Pusher = Pusher;

//     // Initialize Laravel Echo
//     const echo = new Echo({
//       broadcaster: 'pusher',
//       key: 'e166619d1ff73af7fd73',
//       cluster: 'ap2',
//       forceTLS: true,
//     });

//     // Subscribe to the channel and listen for the event
//     const channel = echo.channel('whatsapp-channel');

//     channel.listen('.NewMessageSent', (event) => {
//       console.log('Received raw event:', event);
//       // Update state
//       setMessages((prevMessages) => [
//         ...prevMessages,
//         { phone: event.phone, message: event.message },
//       ]);
//     });

//     // Cleanup when component unmounts
//     return () => {
//       console.log('Disconnecting from Pusher...');
//       echo.disconnect();
//     };
//   }, []);

//   return (
//     <div>
//       <h2>WhatsApp Live Chat</h2>
//       <div>
//         <h3>Chat Messages</h3>
//         {messages.length > 0 ? (
//           messages.map((msg, index) => (
//             <p key={index}>
//               <strong>{msg.phone}:</strong> {msg.message}
//             </p>
//           ))
//         ) : (
//           <p>No messages yet...</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Whatsapp;

// import React, { useState, useEffect } from 'react';
// import Echo from 'laravel-echo';
// import Pusher from 'pusher-js';

// const Whatsapp = () => {
//   const [messages, setMessages] = useState([]);
// console.log('✌️messages --->', messages);

//   useEffect(() => {
//     // Enable Pusher logging for debugging
//     Pusher.logToConsole = true;

//     // Configure Pusher globally
//     window.Pusher = Pusher;

//     // Initialize Laravel Echo
//     const echo = new Echo({
//       broadcaster: 'pusher',
//       key: 'e166619d1ff73af7fd73',
//       cluster: 'ap2',
//       forceTLS: true,
//     });

//     console.log("Attempting to connect to Pusher...");

//     // Subscribe to the channel
//     const channel = echo.channel('whatsapp-channel');

//     channel
//       .subscribed(() => {
//         console.log("✅ Successfully connected to 'whatsapp-channel'");
//       })
//       .error((error) => {
//         console.error("❌ Pusher connection error:", error);
//       });

//     // Listen for incoming messages
//     channel.listen('.NewMessageSent', (event) => {
//       console.log("📩 New message received:", event);
// console.log('✌️event --->', event);
//       setMessages((prevMessages) => [
//         ...prevMessages,
//         { phone: event.phone, message: event.message },
//       ]);
//     });

//     // Cleanup when component unmounts
//     return () => {
//       console.log("🔌 Disconnecting from Pusher...");
//       echo.disconnect();
//     };
//   }, []);

//   return (
//     <div>
//       <h2>WhatsApp Live Chat</h2>
//       <div>
//         <h3>Chat Messages</h3>
//         {messages.map((msg, index) => (
//           <p key={index}>
//             <strong>{msg.phone}:</strong> {msg.message}
//           </p>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Whatsapp;
